import { render, staticRenderFns } from "./home-care.vue?vue&type=template&id=c2964516&scoped=true&"
import script from "./home-care.vue?vue&type=script&lang=js&"
export * from "./home-care.vue?vue&type=script&lang=js&"
import style0 from "./home-care.vue?vue&type=style&index=0&id=c2964516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2964516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
